import React from "react";
import { Navigate, Route, Routes } from "react-router";
import RequestsPage from "./RequestsPage";
import { useAuth } from "../../components";
import RequestCreatePage from "./RequestCreatePage";
import RequestDetailPage from "./RequestDetailPage";

const RequestsShell: React.FC = (): React.ReactElement => {
  const { user } = useAuth();

  if (!user?.isEditor) {
    return <Navigate to="/" />;
  }

  return (
    <Routes>
      <Route path="/:requestId" element={<RequestDetailPage />} />
      <Route path="/create" element={<RequestCreatePage />} />
      <Route index element={<RequestsPage />} />
    </Routes>
  );
};

export default RequestsShell;
